import { useCurrentStateAndParams } from "@uirouter/react";

import { WEBSITE_CONTENT_LOCKED_STATE } from "./websiteContentLockedRoute.constants";

export const useWebsiteContentTouchHookDummyPage = (): boolean => {
    const { state } = useCurrentStateAndParams();

    return state?.name === WEBSITE_CONTENT_LOCKED_STATE;
};
